const getDefaultState = () => {
  return {
    MembresDuGroupe: [],
    MembresNan: [],
    MembresDuGroupeInactifs: [],
    MembresDuGroupe2: [],
    MembresDuGroupeInactifs2: [],
    MembresDuSuperviseur: [],
    MembresDesRegions: [],
    ////////////////
    disable_next: false,
    disable_prev: false,
    //Save first document in snapshot of items received
    firstInResponse: [],
    //Save last document in snapshot of items received
    lastInResponse: [],
    //Keep the array of first document of previous pages
    prev_start_at: [],
    //Maintain the count of clicks on Next Prev button
    pagination_clicked_count: 0,
    paginationSize: 10,
    field: "displayName",
    collection: "membres",
  };
};
const state = getDefaultState();

const mutations = {
  SET_LISTE(state, payload) {
    state.MembresDuGroupe = payload;
    state.MembresDuGroupe2 = payload;
  },

  SET_LISTE(state, payload) {
    state.MembresDuGroupe = payload;
    state.MembresDuGroupe2 = payload;
  },
  SET_LISTE_NAN(state, payload) {
    state.MembresNan = payload;
  },
  SET_LISTE_INACTIFS(state, payload) {
    state.MembresDuGroupeInactifs = payload;
    state.MembresDuGroupeInactifs2 = payload;
  },

  SET_MembresDuSuperviseur(state, payload) {
    state.MembresDuSuperviseur = payload;
  },
  SET_MembresDesRegions(state, payload) {
    state.MembresDesRegions = payload;
  },

  RESET_STATE(state) {
    Object.assign(state, getDefaultState());
  },

  ADD_ONE_ITEM(state, payload) {
    state.MembresDuGroupe.push(payload);
    state.MembresDuGroupe2.push(payload);
  },
};

const actions = {
  resetState({ commit }) {
    commit("RESET_STATE");
  },

  addOneItem({ commit }, item) {
    commit("ADD_ONE_ITEM", item);
    console.log("added to Vuex Membres du superviseur et du groupe", item);
  },
  async getmembresDeRegions({ commit }, arrayRegions) {
    console.log(arrayRegions);
    const self = this;
    const MembresDesRegions = [];
    self._vm.$vloading.show();
    await this._vm.$firebase
      .firestore()
      .collection("membres")
      .where("id_region", "in", arrayRegions)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          MembresDesRegions.push({
            ...doc.data(),
            id: doc.id,
          });
        });
        commit("SET_MembresDesRegions", MembresDesRegions);
        self._vm.$vloading.hide();
      })
      .catch((error) => {
        console.log("Error getting documents: ", error);
      });
  },

  async GetMembresDuGroupe({ commit }, idGroupe) {
    let self = this;

    if (idGroupe) {
      commit("SET_LISTE", []);
      // start requête
      commit("Loading/START_BUSY_STATE", "GetMembresDuGroupe", { root: true });

      let elems = [];

      await this._vm.$firebase
        .firestore()
        .collection("membres")
        .where("id_groupe", "==", idGroupe)
        .where("actif_dans_groupe", "==", 1)
        .orderBy("nom")
        .get()
        .then(
          (snapshot) => {
            if (snapshot.metadata.hasPendingWrites) {
              console.log("il en reste");
              commit("Pending/START_PENDING_STATE", "GetMembresDuGroupe", {
                root: true,
              });
            } else {
              console.log("tout est synchronisé dans Groupes");
              commit("Pending/END_PENDING_STATE", "GetMembresDuGroupe", {
                root: true,
              });
            }
            snapshot.forEach(function (doc) {
              elems.push({
                ...doc.data(),
                id: doc.id,
              });
            });

            if (!elems) {
              let snack = {};
              snack.showSnackbar = true;
              snack.snackbarContent = "Pas d'éléments";
              commit("Snackbar/SET_SNACKBAR", snack, { root: true });
              return false;
            } else {
              commit("SET_LISTE", elems);
              commit("Loading/END_BUSY_STATE", "membres.store.js", {
                root: true,
              });

              var ref = self._vm.$firebase
                .firestore()
                .collection("groupes")
                .doc(idGroupe);
              //update nombre membres: nombreMembres
              //idGroupe
              var nombreMembresActif = _.filter(elems, {
                actif_dans_groupe: 1,
              });
              return ref
                .update({
                  nombreMembres: nombreMembresActif.length,
                })
                .then(() => {
                  console.log("Nombre de membres du groupe modifié!");
                })
                .catch((error) => {
                  console.error("Error updating document: ", error);
                });
            }
          },
          (error) => {
            console.log(error);
            let snackbar = {};
            snackbar.showSnackbar = true;
            snackbar.snackbarContent = error.message;
            commit("Snackbar/SET_SNACKBAR", snackbar, { root: true });
            commit("Loading/END_BUSY_STATE", "membres.store.js", {
              root: true,
            });
          }
        );
    }
  },

  async GetMembresNan({ commit }) {
    console.log("***********************************************");

    let self = this;
    commit("SET_LISTE_NAN", []);
    // start requête
    commit("Loading/START_BUSY_STATE", "GetMembresDuGroupe", { root: true });

    let elems = [];
    await this._vm.$firebase
      .firestore()
      .collection("membres")
     
      .where("sexe", "not-in", [1,0])
      .get()
      .then(
        (snapshot) => {
          snapshot.forEach(function (doc) {
            elems.push({
              ...doc.data(),
              id: doc.id,
            });
          });

          if (!elems) {
            let snack = {};
            snack.showSnackbar = true;
            snack.snackbarContent = "Pas d'éléments";
            commit("Snackbar/SET_SNACKBAR", snack, { root: true });
            return false;
          } else {
            commit("SET_LISTE_NAN", elems);
            commit("Loading/END_BUSY_STATE", "membres.store.js", {
              root: true,
            });
          }
        },
        (error) => {
          console.log(error);
          let snackbar = {};
          snackbar.showSnackbar = true;
          snackbar.snackbarContent = error.message;
          commit("Snackbar/SET_SNACKBAR", snackbar, { root: true });
          commit("Loading/END_BUSY_STATE", "membres.store.js", {
            root: true,
          });
        }
      );
  },

  async GetMembresDuGroupeInactifs({ commit }, idGroupe) {
    let self = this;

    if (idGroupe) {
      commit("SET_LISTE_INACTIFS", []);
      // start requête
      commit("Loading/START_BUSY_STATE", "GetMembresDuGroupeInactifs", {
        root: true,
      });

      let elems = [];

      await this._vm.$firebase
        .firestore()
        .collection("membres")
        .where("id_groupe", "==", idGroupe)
        .where("actif_dans_groupe", "==", 0)
        .orderBy("nom")
        .get()
        .then(
          (snapshot) => {
            if (snapshot.metadata.hasPendingWrites) {
              console.log("il en reste");
              commit(
                "Pending/START_PENDING_STATE",
                "GetMembresDuGroupeInactifs",
                {
                  root: true,
                }
              );
            } else {
              console.log("tout est synchronisé dans Groupes");
              commit("Pending/END_PENDING_STATE", "GetMembresDuGroupe", {
                root: true,
              });
            }
            snapshot.forEach(function (doc) {
              elems.push({
                ...doc.data(),
                id: doc.id,
              });
            });

            if (!elems) {
              let snack = {};
              snack.showSnackbar = true;
              snack.snackbarContent = "Pas d'éléments";
              commit("Snackbar/SET_SNACKBAR", snack, { root: true });
              return false;
            } else {
              commit("SET_LISTE_INACTIFS", elems);
              commit("Loading/END_BUSY_STATE", "membres.store.js", {
                root: true,
              });

              var ref = self._vm.$firebase
                .firestore()
                .collection("groupes")
                .doc(idGroupe);
              //update nombre membres: nombreMembres
              //idGroupe
              var nombreMembresInactifs = _.filter(elems, {
                actif_dans_groupe: 0,
              });
              return ref
                .update({
                  nombreMembresInactifs: nombreMembresInactifs.length,
                })
                .then(() => {
                  console.log("Nombre de membres Inactifs du groupe modifié!");
                })
                .catch((error) => {
                  console.error("Error updating document: ", error);
                });
            }
          },
          (error) => {
            console.log(error);
            let snackbar = {};
            snackbar.showSnackbar = true;
            snackbar.snackbarContent = error.message;
            commit("Snackbar/SET_SNACKBAR", snackbar, { root: true });
            commit("Loading/END_BUSY_STATE", "membres.store.js", {
              root: true,
            });
          }
        );
    }
  },

  async GetMembresDuSuperviseur({ commit, dispatch }, idSuperviseur) {
    let self = this;
    commit("SET_MembresDuSuperviseur", []);
    commit("RESET_STATE");
    // start requête

    commit("Loading/START_BUSY_STATE", "GetMembresDuSuperviseur", {
      root: true,
    });

    let elems = [];
    let elemsTemp = [];
    await this._vm.$firebase
      .firestore()
      .collection("membres")
      .where("id_responsable", "==", idSuperviseur)
      .where("actif_dans_groupe", "==", 1)
      .get()
      .then(
        (snapshot) => {
          snapshot.forEach(function (doc) {
            elemsTemp.push({
              ...doc.data(),
              id: doc.id,
            });
          });

          if (!elemsTemp) {
            let snack = {};
            snack.showSnackbar = true;
            snack.snackbarContent = "Pas d'éléments";
            commit("Snackbar/SET_SNACKBAR", snack, { root: true });
            return false;
          } else {
            /*  elems = _.filter(elemsTemp, { actif_dans_groupe: 1 }); */

            commit("SET_MembresDuSuperviseur", elemsTemp);
            commit("Loading/END_BUSY_STATE", "membres.store.js", {
              root: true,
            });

            dispatch(
              "Utils/markLoaded",
              { type: "membresLoaded" },
              {
                root: true,
              }
            );
          }
        },
        (error) => {
          console.log(error);
          let snackbar = {};
          snackbar.showSnackbar = true;
          snackbar.snackbarContent = error.message;
          commit("Snackbar/SET_SNACKBAR", snackbar, { root: true });
          commit("Loading/END_BUSY_STATE", "membres.store.js", { root: true });
        }
      );
  },
  deleteMembre({ commit }, idMembre) {
    let self = this;
    console.log("Membre à supprimer: ", idMembre);
    this._vm.$firebase
      .firestore()
      .collection("membres")
      .doc(idMembre)
      .delete()
      .then(() => {
        console.log("Deleted membre : ", idMembre);

        /** delete presencesFormationsGroupes */
        const presencesFormationsGroupes = self._vm.$firebase
          .firestore()
          .collection("presencesFormationsGroupes");
        presencesFormationsGroupes
          .where("membres_id_membre", "==", idMembre)
          .get()
          .then((snapshots) => {
            console.log(
              "Presences Formations De groupe de membre successfully deleted!"
            );
            if (snapshots.size > 0) {
              snapshots.forEach((snap) => {
                presencesFormationsGroupes.doc(snap.id).delete();
              });
            } else {
              console.log("no snap presencesFormationsGroupes de membre");
            }
          });
        /** End delete presencesFormationsGroupes */

        /** delete presencesDotationsGroupes */
        const presencesDotationsGroupes = self._vm.$firebase
          .firestore()
          .collection("presencesDotationsGroupes");
        presencesDotationsGroupes
          .where("membres_id_membre", "==", idMembre)
          .get()
          .then((snapshots) => {
            console.log(
              "Presences Dotations De groupe de membre successfully deleted!"
            );
            if (snapshots.size > 0) {
              snapshots.forEach((snap) => {
                presencesDotationsGroupes.doc(snap.id).delete();
              });
            } else {
              console.log("no snap presencesDotationsGroupes de membre");
            }
          });
        /** End delete presencesDotationsGroupes */

        /** delete fiches */
        const fiches = self._vm.$firebase.firestore().collection("fiches");
        fiches
          .where("membres_id_membre", "==", idMembre)
          .get()
          .then((snapshots) => {
            console.log("fiches de membre successfully deleted!");
            if (snapshots.size > 0) {
              snapshots.forEach((snap) => {
                fiches.doc(snap.id).delete();
              });
            } else {
              console.log("no snap fiches de membre");
            }
          });
        /** End delete fiches */
      })
      .catch((error) => {
        console.error("Error removing membre: ", error);
      });
  },
  async UpdateMembreDansAutresCollections({ commit }, objet) {
    let self = this;

    /** update presencesFormationsGroupes */
    const presencesFormationsGroupes = self._vm.$firebase
      .firestore()
      .collection("presencesFormationsGroupes");
    presencesFormationsGroupes
      .where("membres_id_membre", "==", objet.userId)
      .get()
      .then((snapshots) => {
        console.log(
          "Presences Formations De groupe de membre successfully updated!"
        );
        if (snapshots.size > 0) {
          snapshots.forEach((snap) => {
            presencesFormationsGroupes
              .doc(snap.id)
              .set(objet.data, { merge: true });
          });
        } else {
          console.log("no snap presencesFormationsGroupes de membre");
        }
      });
    /** End update presencesFormationsGroupes */

    /** update presencesDotationsDeGroupes */
    const presencesDotationsDeGroupes = self._vm.$firebase
      .firestore()
      .collection("presencesDotationsGroupes");
    presencesDotationsDeGroupes
      .where("membres_id_membre", "==", objet.userId)
      .get()
      .then((snapshots) => {
        console.log(
          "Presences Dotations De groupe de membre successfully updated!"
        );
        if (snapshots.size > 0) {
          snapshots.forEach((snap) => {
            presencesDotationsDeGroupes
              .doc(snap.id)
              .set(objet.data, { merge: true });
          });
        } else {
          console.log("no snap presencesDotationsDeGroupes de membre");
        }
      });
    /** End update presencesDotationsDeGroupes */

    /** update fiches */
    const fiches = self._vm.$firebase.firestore().collection("fiches");
    fiches
      .where("membres_id_membre", "==", objet.userId)
      .get()
      .then((snapshots) => {
        console.log("fiches de membre successfully updated!");
        if (snapshots.size > 0) {
          snapshots.forEach((snap) => {
            fiches.doc(snap.id).set(objet.data, { merge: true });
          });
        } else {
          console.log("no snap fiches de membre");
        }
      });
    /** End update fiches */
  },
};

const getters = {
  MembresDuGroupe: (state) => {
    return state.MembresDuGroupe;
  },
  MembresDuSuperviseur: (state) => {
    return state.MembresDuSuperviseur;
  },
  MembresDesRegions: (state) => {
    return state.MembresDesRegions;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
